<template>
  <div class="app-container">
    <list ref="list"></list>
  </div>
</template>
<script>
import list from '@/components/sys/initialize/initinventory/list'

export default {
  name: "initinventory",
  components: {
    list,
  },
  methods: {}
};
</script>